<div [class]="clazz" style="{{getBackgroundImageStyle()}}" #ref></div>


